import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { WATCHTOWER_API_URL } from '../config/api-url';

const watchtowerClient = axios.create({
  baseURL: WATCHTOWER_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const handleError = (error, rejectWithValue) => {
  const message = error.response?.data?.detail || error.message;
  return rejectWithValue(message);
};

export const fetchWatchtowerCampaigns = createAsyncThunk(
  'watchtower/fetchCampaigns',
  async ({ params } = {}, { rejectWithValue }) => {
    try {
      const response = await watchtowerClient.get('/watchtower/campaigns', {
        params,
      });
      return response.data;
    } catch (error) {
      return handleError(error, rejectWithValue);
    }
  }
);

export const fetchWatchtowerAdsets = createAsyncThunk(
  'watchtower/fetchAdsets',
  async ({ campaignId, params } = {}, { rejectWithValue }) => {
    if (!campaignId) {
      return rejectWithValue('campaignId is required to fetch ad sets');
    }
    try {
      const response = await watchtowerClient.get(
        `/watchtower/campaigns/${campaignId}/adsets`,
        {
          params,
        }
      );
      return { ...response.data, campaignId };
    } catch (error) {
      return handleError(error, rejectWithValue);
    }
  }
);

export const fetchWatchtowerAds = createAsyncThunk(
  'watchtower/fetchAds',
  async ({ adsetId, params } = {}, { rejectWithValue }) => {
    if (!adsetId) {
      return rejectWithValue('adsetId is required to fetch ads');
    }
    try {
      const response = await watchtowerClient.get(
        `/watchtower/adsets/${adsetId}/ads`,
        {
          params,
        }
      );
      return { ...response.data, adsetId };
    } catch (error) {
      return handleError(error, rejectWithValue);
    }
  }
);
